var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.sub_page === 'verify')?_c('Verify'):_vm._e(),(_vm.sub_page === 'pharminfo')?_c('PharmInfo'):_vm._e(),(_vm.sub_page === 'admin')?_c('Admin'):_vm._e(),(_vm.sub_page === 'password')?_c('Password'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }